import type { IconNode } from '../types';

/**
 * @name carton-off
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuMSA4LjUgMTYgNlYzYzAtLjYtLjQtMS0xLTFIOSIgLz4KICA8cGF0aCBkPSJNMTEuNyA2SDE2bDMgNHYzLjMiIC8+CiAgPHBhdGggZD0ibTIgMiAyMCAyMCIgLz4KICA8cGF0aCBkPSJNMTkgMTl2MWEyIDIgMCAwIDEtMiAySDdhMiAyIDAgMCAxLTItMlYxMGwyLjEtMi45IiAvPgogIDxwYXRoIGQ9Ik0xMyAxM3Y5IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/carton-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cartonOff: IconNode = [
  ['path', { d: 'M14.1 8.5 16 6V3c0-.6-.4-1-1-1H9', key: '6g1v9i' }],
  ['path', { d: 'M11.7 6H16l3 4v3.3', key: '1yga5t' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M19 19v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10l2.1-2.9', key: '1ybudx' }],
  ['path', { d: 'M13 13v9', key: '10i1hi' }],
];

export default cartonOff;
